// @ts-check
import React, { useEffect } from "react";
import { useLocation } from "react-router";

/**
 * ScrollToTop
 * @description
 * A component to be wrapped around react-router routes so that they get automatically
 * scrolled to the top when the location changes.
 * @param {object} props
 * @param {JSX.Element | JSX.Element[]} props.children
 * @returns JSX.Element
 */
export default function ScrollToTop({ children }) {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
}
